document.addEventListener("DOMContentLoaded", function () {
    const sectionEl = document.querySelector("section[data-items-per-page]");
    const itemsPerPage = parseInt(sectionEl.dataset.itemsPerPage, 10) || 5;

    const triviaItems = document.querySelectorAll(".tea-trivia-inner-wrapper");
    const paginationContainer = document.getElementById("pagination");
    const totalPages = Math.ceil(triviaItems.length / itemsPerPage);
    let currentPage = 1;
  
    function showPage(page) {
        triviaItems.forEach((item, index) => {
            item.classList.toggle(
                "hidden",
                !(index >= (page - 1) * itemsPerPage && index < page * itemsPerPage)
            );
        });
    }
  
    function renderPagination() {
        paginationContainer.innerHTML = "";
        let pages = [];
  
        if (totalPages <= 7) {
            for (let i = 1; i <= totalPages; i++) pages.push(i);
        } else {
            pages.push(1, 2, 3);
  
            if (currentPage > 5) pages.push("...");
  
            let start = Math.max(4, currentPage - 1);
            let end = Math.min(totalPages - 3, currentPage + 1);
  
            if (start > 3 && end < totalPages - 2) {
                for (let i = start; i <= end; i++) pages.push(i);
            }
  
            if (currentPage < totalPages - 4) pages.push("...");
  
            pages.push(totalPages - 2, totalPages - 1, totalPages);
        }
  
        pages.forEach((num) => {
            const element = document.createElement(num === "..." ? "span" : "button");
            element.textContent = num;
            if (num !== "...") {
                element.classList.toggle("active", num === currentPage);
                element.addEventListener("click", () => {
                    currentPage = num;
                    showPage(currentPage);
                    renderPagination();
                });
            }
            paginationContainer.appendChild(element);
        });
    }
  
    showPage(currentPage);
    renderPagination();
});